{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit NetEncoding;

interface

uses
  SysUtils;

type
  TNetEncoding = class(TObject)
  strict private class var
    FBase64: TNetEncoding;
    FURL: TNetEncoding;
  strict private
    class function get_Base64: TNetEncoding; static;
    class function get_URL: TNetEncoding; static;
  strict protected
    function DoDecode(const AInput: string): string; overload; virtual; abstract;
    function DoDecode(const AInput: TBytes): TBytes; overload; virtual;
    function DoDecodeStringToBytes(const AInput: string): TBytes; virtual;
    function DoEncode(const AInput: string): string; overload; virtual; abstract;
    function DoEncode(const AInput: TBytes): TBytes; overload; virtual;
    function DoEncodeBytesToString(const AInput: TBytes): string; virtual;
  public
    function Decode(const AInput: string): string; overload;
    function Decode(const AInput: TBytes): TBytes; overload;
    function DecodeStringToBytes(const AInput: string): TBytes;
    function Encode(const AInput: string): string; overload;
    function Encode(const AInput: TBytes): TBytes; overload;
    function EncodeBytesToString(const AInput: TBytes): string;
    class property Base64: TNetEncoding read get_Base64;
    class property URL: TNetEncoding read get_URL;
  end;

  TBase64Encoding = class(TNetEncoding)
  strict protected
    function DoDecode(const AInput: string): string; overload; override;
    function DoEncode(const AInput: string): string; overload; override;
  end;

  TURLEncoding = class(TNetEncoding)
  strict protected
    function DoDecode(const AInput: string): string; overload; override;
    function DoEncode(const AInput: string): string; overload; override;
  end;

implementation

uses
  JS, Web;

{ TNetEncoding }

function TNetEncoding.Decode(const AInput: string): string;
begin
  Result := TEncoding.UTF8.GetString(DoDecode(TEncoding.UTF8.GetBytes(AInput)));
end;

function TNetEncoding.Decode(const AInput: TBytes): TBytes;
begin
  Result := DoDecode(AInput);
end;

function TNetEncoding.DecodeStringToBytes(const AInput: string): TBytes;
begin
  Result := DoDecodeStringToBytes(AInput);
end;

function TNetEncoding.DoDecode(const AInput: TBytes): TBytes;
begin
  if Length(AInput) > 0 then
    Result := DoDecodeStringToBytes(TEncoding.ANSI.GetString(AInput))
  else
    Result := nil;
end;

function TNetEncoding.DoDecodeStringToBytes(const AInput: string): TBytes;
begin
  Result := TEncoding.ANSI.GetBytes(DoDecode(AInput));
end;

function TNetEncoding.DoEncode(const AInput: TBytes): TBytes;
begin
  if Length(AInput) > 0 then
    Result := TEncoding.ANSI.GetBytes(DoEncodeBytesToString(AInput))
  else
    Result := nil;
end;

function TNetEncoding.DoEncodeBytesToString(const AInput: TBytes): string;
begin
  Result := DoEncode(TEncoding.ANSI.GetString(AInput));
end;

function TNetEncoding.Encode(const AInput: string): string;
begin
  Result := TEncoding.UTF8.GetString(DoEncode(TEncoding.UTF8.GetBytes(AInput)));
end;

function TNetEncoding.Encode(const AInput: TBytes): TBytes;
begin
  Result := DoEncode(AInput);
end;

function TNetEncoding.EncodeBytesToString(const AInput: TBytes): string;
begin
  Result := DoEncodeBytesToString(AInput);
end;

class function TNetEncoding.get_Base64: TNetEncoding;
begin
  if FBase64 = nil then
    FBase64 := TBase64Encoding.Create;
  Result := FBase64;
end;

class function TNetEncoding.get_URL: TNetEncoding;
begin
  if FURL = nil then
    FURL := TURLEncoding.Create;
  Result := FURL;
end;

{ TBase64Encoding }

function TBase64Encoding.DoDecode(const AInput: string): string;
begin
  Result := window.atob(AInput);
end;

function TBase64Encoding.DoEncode(const AInput: string): string;
begin
  Result := window.btoa(AInput);
end;

{ TURLEncoding }

function TURLEncoding.DoDecode(const AInput: string): string;
begin
  Result := decodeURIComponent(AInput);
end;

function TURLEncoding.DoEncode(const AInput: string): string;
begin
  Result := encodeURIComponent(AInput);
end;

end.
